import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=d6c5f9bc&"
import script from "./projectManagement.vue?vue&type=script&lang=js&"
export * from "./projectManagement.vue?vue&type=script&lang=js&"
import style0 from "./projectManagement.vue?vue&type=style&index=0&id=d6c5f9bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports